// Troca de aba das vitrines — ver sections/vitrine-abas.liquid
document.querySelectorAll('[data-vitrine-abas]').forEach((vitrine) => {
  const abas = [...vitrine.querySelectorAll('[role="tab"]')];

  const ativar = (aba) => {
    abas.forEach((outra) => {
      const ativa = outra === aba;
      outra.setAttribute('aria-selected', String(ativa));
      outra.tabIndex = ativa ? 0 : -1;
      const painel = document.getElementById(outra.getAttribute('aria-controls'));
      if (painel) painel.hidden = !ativa;
    });
  };

  abas.forEach((aba, indice) => {
    aba.tabIndex = indice === 0 ? 0 : -1;
    aba.addEventListener('click', () => ativar(aba));
    aba.addEventListener('keydown', (evento) => {
      const passo = { ArrowRight: 1, ArrowLeft: -1 }[evento.key];
      if (!passo) return;
      const proxima = abas[(indice + passo + abas.length) % abas.length];
      proxima.focus();
      ativar(proxima);
    });
  });
});
